import * as React from "react";
const Show = props => <symbol viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M12 19.75c-4.523 0-8.21-2.394-10.66-6.926a1.726 1.726 0 010-1.648C3.79 6.645 7.477 4.25 12 4.25c4.523 0 8.209 2.395 10.66 6.926a1.73 1.73 0 010 1.648C20.208 17.356 16.522 19.75 12 19.75zm0-14c-3.995 0-7.137 2.065-9.34 6.14a.232.232 0 000 .22c2.203 4.075 5.345 6.14 9.34 6.14 3.994 0 7.137-2.065 9.34-6.14a.235.235 0 000-.22C19.138 7.815 15.995 5.75 12 5.75z" />
      <path d="M12 15.75a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5zm0-6a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" />
    </g>
  </symbol>;
export default Show;